import { ReactNode } from 'react'

import { NamePath } from 'antd/es/form/interface'

export const makeArrayFieldName = (fieldName: string | string[], suffix: string) => {
  return Array.isArray(fieldName) ? [...fieldName, suffix] : [fieldName, suffix]
}

export const makeHiddenFieldName = (
  fieldName: string | string[],
  index: number | null | undefined,
  str: string
) => {
  if (index === null || index === undefined) {
    return makeArrayFieldName(fieldName, str)
  }
  const base = makeArrayFieldName(fieldName, `${index}`)
  return makeArrayFieldName(base, str)
}

export const makeSelectedIdFieldName = (
  fieldName: string | string[],
  index: number | undefined
) => {
  return makeFieldNameVariableOnIndex(fieldName, index, 'selectedId')
}

export const makeManualAddressFieldName = (
  fieldName: string | string[],
  index: number | undefined
) => {
  return makeFieldNameVariableOnIndex(fieldName, index, 'manualAddress')
}

export const makeFieldNameVariableOnIndex = (
  fieldName: string | string[],
  index: number | undefined,
  str: string
) => {
  const base = index !== null && index !== undefined ? `${index}` : fieldName
  const res = makeArrayFieldName(base, str)
  return res
}

export const getLabelStr = (label: ReactNode): string | undefined => {
  if (typeof label === 'string') {
    return label
  }
  return undefined
}

export const makeFieldNameWithPrefix = (
  fieldName: string | string[],
  fieldNamePrefix?: string | string[]
): NamePath => {
  if (!fieldNamePrefix) {
    return fieldName
  }

  return [
    ...(Array.isArray(fieldNamePrefix) ? fieldNamePrefix : [fieldNamePrefix]),
    ...(Array.isArray(fieldName) ? fieldName : [fieldName]),
  ]
}

export interface WrapperChildParams {
  errorMessage: string | undefined
  onValueChange: (newValue: any) => void
  tooltip?: string | null
  value: any
}

const emptyRegex = new RegExp(/^<p>(\s*|<br>)<\/p>$/)
export const getIsRichTextEmpty = (text: string | null | undefined): text is null | undefined => {
  return !text?.trim() || emptyRegex.test(text)
}
